import React, {useCallback, useEffect, useState} from "react";
import {useLocation} from 'react-router-dom';
import {useTranslation} from "react-i18next";
//MUI
import {
    Box,
    Button,
    Checkbox,
    Container,
    Divider,
    Grid,
    Stack,
    Backdrop,
    Chip,
    CircularProgress,
    Typography,
    Modal
} from "@mui/material";

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import {theme} from '../../assets/themes';
import UButton from "../../components/mui/UButton";
import UAuthButton from "../../components/mui/UAuthButton";
import UBreadCrumbs from "../../components/mui/UBreadCrumbs";
import UConfirmDialog from "../../components/mui/UConfirmDialog";
import UAlertDialog from "../../components/mui/UAlertDialog";
import UPopupForm from "../../components/mui/UPopupForm";
import UTable from "../../components/mui/UTable";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import MachineModify from "../../pages/oper/MachineModify";
import {API, PAGE} from "../../config";
import {fni18n, bytesToSize} from "../../services/commonService";
import {
    getAPI
    , postAPI
    , putAPI
    , deleteAPI
} from "../../services/commonService";
import {FileService} from "../../services/FileService";
import AuthenticationService from "../../pages/auth/AuthenticationService";
import USelectBox from "../../components/mui/USelectBox";
import {makeStyles} from "@material-ui/core/styles";

export default function MachinePage() {
    const {t} = useTranslation();
    const userLoginId = AuthenticationService.getLoggedInUserID();
    const columns = [
        {
            field: 'id',
            headerName: '번호',
            hide: true,
        },
        {
            field: 'storeCd',
            headerName: '지점',
            hide: true,
        },
        {
            field: 'storeNm',
            headerName: '지점명',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'machineNo',
            headerName: '기기번호',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'model',
            headerName: '기종',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'ip',
            headerName: 'IP',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'port',
            headerName: 'PORT',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
            hide:true,
        },
        {
            field: 'serialNo',
            headerName: '일련번호',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'installDate',
            headerName: '설치일',
            width: "11%",
            editable: false,
            align: "center",
            headerAlign: "center"
        },
        {
            field: 'useYn',
            headerName: '사용여부',
            width: "11%",
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params) => {
                if (params.value == "Y") {
                    return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}}/>
                } else {
                    return <Checkbox checked={false} disabled/>
                }
            }
        },
        {
            field: 'rctPrtYn',
            headerName: '명세표 출력여부',
            width: "11%",
            editable: false,
            align: "center",
            headerAlign: "center",
            valueFormatter: (params) => {
                if (params.value == "Y") {
                    return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}}/>
                } else {
                    return <Checkbox checked={false} disabled/>
                }
            }
        },
        {
            field: 'autoUnloadOpt',
            headerName: '자동회수방식',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'manualUnloadOpt',
            headerName: '수동회수방식',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'ifYn',
            headerName: '액세스키',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
            valueFormatter: (params) => {
                if (params.value == "Y") {
                    return <Checkbox checked={true} disabled style={{color: theme.palette.primary.main}}/>
                } else {
                    return <Checkbox checked={false} disabled/>
                }
            }
        },
        {
            field: 'description',
            headerName: '설명',
            width: "11%",
            editable: false,
            headerAlign: 'center',
            align: 'center',
        },
        {
            field: 'usdBill100MaxCnt',
            headerName: '$100',
            hide: true,
        },
        {
            field: 'usdBill50MaxCnt',
            headerName: '$50',
            hide: true,
        },
        {
            field: 'usdBill20MaxCnt',
            headerName: '$20',
            hide: true,
        },
        {
            field: 'usdBill10MaxCnt',
            headerName: '$10',
            hide: true,
        },
        {
            field: 'usdBill5MaxCnt',
            headerName: '$5',
            hide: true,
        },
        {
            field: 'usdBill1MaxCnt',
            headerName: '$1',
            hide: true,
        },
        {
            field: 'button',
            headerName: '설정',
            sortable: false,
            width: "11%",
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) =>
                (
                    <UButton
                        variant="outlined"
                        onButtonClick={() => handleRowSelect(params.rows)}
                        menuFrom={location.pathname}
                    >
                        보기
                    </UButton>
                ),
        },
    ];

    const location = useLocation();

    const [branchs, setBranch] = useState([]);
    const [machineNo, setMachineNo] = useState([]);
    const [useYn, setUseYn] = useState([
        {cd: 'Y', name: 'Y'},
        {cd: 'N', name: 'N'},
    ]);
    const [rctPrtYn, setRctPrtYn] = useState([
        {cd: 'Y', name: 'Y'},
        {cd: 'N', name: 'N'},
    ]);
    const [search, setSearch] = useState({
        // branch: "N/A",
    });
    const [list, setList] = useState([]);

    let isRemoteConfirmEvent = false;
    const [remoteConfirmPopupOpen, setRemoteConfirmPopupOpen] = useState(false); // confirm dialog
    const [remoteConfirmMsg, ] = useState(t("즉시 적용하시겠습니까?"));
    const [confirmPopupOpen, setConfirmPopupOpen] = useState(false); // confirm dialog
    const [errorPopupOpen, setErrorPopupOpen] = useState(false); // error dialog
    const [errorMsg, setErrorMsg] = useState(""); // api error message
    const [confirmMsg, setConfirmMsg] = useState(""); // api error message
    const [confirmEvent, setConfirmEvent] = useState("");
    const [formOpen, setFormOpen] = useState(false);
    const [modify, setModify] = useState({
        storeCd: "N/A",
        storeNm: "",
        machineNo: "",
        model: "",
        serialNo: "",
        useYn: "Y",
        ip: "0.0.0.0",
        port: "",
        installDate: "",
        description: "",
        cnt100D: 0,
        cnt50D: 0,
        cnt20D: 0,
        cnt10D: 0,
        cnt5D: 0,
        cnt1D: 0,
        rctPrtYn: "Y",
        // ifYn: "N",
        autoUnloadOpt: "CST",
        manualUnloadOpt:"CST",
    });
    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [excelFormOpen, setexcelFormOpen] = useState(false); //엑셀업로드 팝업
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [backdropOpen, setBackdropOpen] = useState(false);
    const [retailers, setRetailers] = useState([]);
    const [isLoading, setIsLoading] = useState(false); // 로딩 상태 관리

    //화면 로드 시
    useEffect(() => {
        window.scrollTo(0, 0);
        const getLoadData = async () => {
            try {
                await Promise.all([
                    loadComboBoxBranchGroup(),
                    loadComboBoxBranch()
                ]);
            } catch (e) {
                console.error('초기 로딩 실패:', e.message);
            }
        };
        getLoadData();
    }, []);

    useEffect(() => {
        if (!isFirstLoad) return;
        if (search.branch) {
            onButtonClick("조회");
            setIsFirstLoad(false);
        }
    }, [search]);

    const clearSearchVal = ()=>{
        setSearch({
            ...search,
            ['branch']: 'N/A',
        });
        setMachineNo([]);
    }

    // 콤보박스 데이터
    const loadComboBoxBranchGroup = async () => {
        try {
            const res = await getAPI(API.COMMON.BRANCH_GROUP, {userId: userLoginId,branchGroupTy: "BIZ_TY",useYn:"Y"});
            const _inputData = res.data.result.map((m) => ({
                cd: m.id,
                name: m.branchGroupNm,
            }));
            setRetailers(_inputData);
            // await loadComboBoxBranch(_inputData[0].cd);
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxBranch = async (param) => {
        try {
            const res = await getAPI(API.COMMON.BRANCH, { userId: userLoginId, bizTy:param, });
            const _inputData = res.data.result.map((m) => ({
                    cd: m.storeCd,
                    name: m.storeNm,
                })
            );
            setBranch(_inputData);
            if (_inputData.length > 0) {
                setSearch({
                    ...search,
                    ['branch']: _inputData[0].cd,
                })
                await loadComboBoxMachineNo(_inputData[0].cd);
            } else {
                clearSearchVal()
            }
        } catch (e) {
            console.error(e.message);
        }
    };
    const loadComboBoxMachineNo = async (branch) => {
        try {
            const res = await getAPI(API.COMMON.MACHINE + branch);
            const _inputData = res.data.result.map((m) => ({
                    cd: m.machId,
                    name: m.machId,
                })
            );
            setMachineNo(_inputData);
        } catch (e) {
            console.error(e.message);
        }
    };
    const handleConfirmOpen = (e) => {
        setConfirmPopupOpen(true);
        setConfirmEvent(e)
    };
    const handleConfirmClose = () => {
        setConfirmPopupOpen(false);
    };
    const handleRemoteConfirmOpen = () => {
        handleConfirmClose()
        if (confirmEvent === "post"){
            handelConfirmEvent()
        } else if(confirmEvent === "put"){
            setRemoteConfirmPopupOpen(true);
        }
    };
    const handleRemoteConfirmClose = () => {
        setRemoteConfirmPopupOpen(false)
        isRemoteConfirmEvent=false
        handelConfirmEvent()
    };
    const handleRemoteConfirmOk = () => {
        setRemoteConfirmPopupOpen(false)
        isRemoteConfirmEvent=true
        handelConfirmEvent()
    };
    /**처리성공 시 팝업 띄우지 않는다. 실패 시에만 팝업 띄운다 */
    /**처리실패 시에는 창 닫지 않는다. 성공 시에만 자동 closed.*/
    const handelConfirmEvent = async () => {
        try {
            if (confirmEvent === "put") {
                await putAPI(API.OPER.MACHINE, modify).then((res) => {
                    if (res.data.code === 200) {
                        handleFormClose();
                        if (isRemoteConfirmEvent){
                            sendRemoteCmd(modify.ip, modify.port, "reopen")
                        }
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            } else if (confirmEvent === "post") {
                await postAPI(API.OPER.MACHINE, modify).then((res) => {
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            } else if (confirmEvent === "delete") {
                await deleteAPI(API.OPER.MACHINE, modify).then((res) => {
                    if (res.data.code === 200) {
                        handleFormClose();
                    } else {
                        setErrorMsg(t("처리가 실패하였습니다"))
                        handleErrorOpen();
                    }
                })
            }
        } catch (error) {
            console.log(error)
        } finally {
            handleConfirmClose();
            await onButtonClick("조회");
        }
    };

    const handleErrorOpen = () => {
        setErrorPopupOpen(true);
    };
    const handleErrorClose = () => {
        setErrorPopupOpen(false);
    };

    const handleRowSelect = (row) => {
        setModify({
            storeCd: row.storeCd,
            storeNm: row.storeNm,
            machineNo: row.machineNo,
            model: row.model,
            serialNo: row.serialNo,
            useYn: row.useYn,
            ifYn: row.ifYn,
            ip: row.ip,
            port: row.port,
            installDate: row.installDate,
            description: row.description,
            chkCreate: row.storeCd || "",
            cnt100D: row.usdBill100MaxCnt,
            cnt50D: row.usdBill50MaxCnt,
            cnt20D: row.usdBill20MaxCnt,
            cnt10D: row.usdBill10MaxCnt,
            cnt5D: row.usdBill5MaxCnt,
            cnt1D: row.usdBill1MaxCnt,
            rctPrtYn: row.rctPrtYn,
            autoUnloadOpt: row.autoUnloadOpt,
            manualUnloadOpt: row.manualUnloadOpt,
            safeId: row.storeCd+row.machineNo,
        })
        handleFormOpen();   //상세팝업
    }

    const handleFormOpen = () => {
        setFormOpen(true);
    };
    const handleFormClose = () => {
        setFormOpen(false);
    };

    const handleExcelFormOpen = () => {
        setexcelFormOpen(true);
    };
    const handleExcelFormClose = () => {
        setexcelFormOpen(false);
    };

    //DataGrid에서 row 선택 시 
    function onSelectedRow(row) {

    };
    const onSelectedRows = (e, row) => {
    };
    //value 속성으로만 값을 컨트롤 할 수 있어서 
    //onChange를 써서 element를 수정할 수 있는 상태로 만듦
    const onModifyChange = (e) => {
        const {name, value} = e.target;
        setModify({
            ...modify,
            [name]: value,
        });
    };
    const onModifyStoreChage = (e) => {
        setModify({
            ...modify,
            "storeCd": e.storeCd.value,
        })
    };

    const onIpChange = (e) => {
        setModify({
            ...modify,
            ip: e,
        });
    };

    //검색조건 값 변경되었을 때
    const onSearchChange = async (e) => {
        const {name, value} = e.target;
        setSearch({
            ...search,
            [name]: value,
        })
        if (name === "bizTy") {
            loadComboBoxBranch(value);
        }
        if (name == 'branch') {
            await loadComboBoxMachineNo(value);
        }
    }

    const onCheckboxChange = (e) => {
        setModify({
            ...modify,
            [e.target.name]: e.target.checked === true ? "Y" : "N",
        });
    };

    const onRadioButtonChange = (e) => {
        setModify({
            ...modify,
            autoUnloadOpt: e.autoUnloadOpt,
            manualUnloadOpt:e.manualUnloadOpt,
        });
    }

    async function onButtonClick(dvsn) {
        if (dvsn === "조회") {
            await getAPI(API.OPER.MACHINE, search).then((res) => {
                if (res.data.code === 200) {
                    setList(res.data.result);
                } else {
                    setErrorMsg(t("처리가 실패하였습니다"))
                    handleErrorOpen();
                }
            })
        } else if (dvsn === "추가") {
            const row = ({
                storeCd: "",
                storeNm: "",
                machineNo: "",
                model: "",
                serialNo: "",
                useYn: "Y",
                ifYn: "N",
                ip: "0.0.0.0",
                port: "",
                installDate: "",
                description: "",
                usdBill100MaxCnt: 0,
                usdBill50MaxCnt: 0,
                usdBill20MaxCnt: 0,
                usdBill10MaxCnt: 0,
                usdBill5MaxCnt: 0,
                usdBill1MaxCnt: 0,
                rctPrtYn: "Y",
                autoUnloadOpt: "CST"
            });
            handleRowSelect(row);
        } else if (dvsn == "업로드") {
            var fileCnt = selectedFiles.length;
            if (fileCnt < 1) {
                setErrorMsg("선택된 파일이 없습니다. 파일을 선택해주세요.");//en,kr
                handleErrorOpen();
                return;
            }
            uploadExcelFile();
        } else {
            setErrorMsg(t("알 수 없는 오류가 발생하였습니다"))
            handleErrorOpen();
        }
    };
    const onSave = async (e) => {
        let flag;
        await getAPI(API.OPER.MACHINE + '/duplicateCheck', modify).then((res) => {
            flag = res.data;
        })
        if (flag == -1) {
            setErrorMsg(t("지점") + " " + t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        } else if (flag == -2) {
            setErrorMsg(t("기기번호") + " " + t("은(는) 필수 입력 항목입니다"));
            handleErrorOpen();
        } else if (flag == 0) {
            setConfirmMsg(t("등록하시겠습니까?"));
            handleConfirmOpen("post");
        } else if (flag > 0) {
            setConfirmMsg(t("정보를 수정하시겠습니까?") + " " + modify.storeNm + " " + modify.machineNo);
            handleConfirmOpen("put");
        }
    }

    // 엑셀 업로드
    const fnExcelBrowser = () => {
        const element = document.createElement('input');
        element.name = "file";
        element.type = "file";
        element.accept = ".xlsx, .xls, .csv";
        element.multiple = false;
        element.onchange = onSaveFile;
        element.click();
    };

    const handleDelete = (chipToDelete) => () => {
        setSelectedFiles((chips) => chips.filter((chip) => chip.key !== chipToDelete.key));
    };
    const onSaveFile = (e) => {
        const uploadFiles = Array.prototype.slice.call(e.target.files); // 파일선택창에서 선택한 파일들
        const _inputData = uploadFiles.map((m, i) => ({
            key: `file-+${i}`,
            label: `${m.name} (${bytesToSize(m.size)})`,
            file: m,
        }));
        setSelectedFiles(_inputData);
    };

    const uploadExcelFile = async () => {
        const fd = new FormData();

        Object.values(selectedFiles).forEach((f) => (
            fd.append("file", f.file)
        ));
        fd.append("page", "mach");

        try {
            await FileService.files(API.COMMON.UPLOAD_EXCEL, fd).then((res) => {
                console.log(res);
                if (res.status == '200' && res.data != "") {
                    let message = ""
                    if (res.data.errCode === -1) {
                        message = t(res.data.errMsg);
                    } else {
                        message = t("파일 업로드 데이터 저장") + "\n\n["
                            + t("저장 결과") + "]\n* "
                            + t("전체 개수") + " : " + res.data.total + "\n* "
                            + t("성공 개수") + " : " + res.data.success + "\n* "
                            + t("실패 개수") + " : " + res.data.fail;
                        if (res.data.fail !== 0)
                            message += " (" + res.data.failNoList.map(n => `No. ${n}`).join(', ') + ")";
                    }
                    setErrorMsg(message);
                    handleErrorOpen();
                    onButtonClick("조회");
                    handleExcelFormClose();
                } else {
                    setErrorMsg(t("실패"));
                    handleErrorOpen();
                    handleExcelFormClose();
                }
            });
        } catch (e) {
            console.log(e.message);
        }
    }

    const sendRemoteCmd = async (ip, port, command) => {
        console.log(ip, port, command);
        if (!ip || ip === "undefined" || typeof ip === "undefined") {
            alert("IP " + t("정보가 존재하지 않습니다."));
            return;
        }
        if (!port || port === "undefined" || typeof port === "undefined") {
            alert("Port " + t("정보가 존재하지 않습니다."));
            return;
        }
        if (!command || command === "undefined" || typeof command === "undefined") {
            alert(t("원격명령을 선택해주세요."));
            return;
        }

        setIsLoading(true);  // 로딩 시작
        try {
            const token = Math.floor(Math.random() * 1000000) + 1;
            const CmdTokUrl = `https://${ip}:${port}/svc/if/setCMDToken?token=${token}`;

            await getAPI(CmdTokUrl).then((res) => {
                if (res && res.status === 200) {
                    const cmd = command;
                    const CmdkUrl = `https://${ip}:${port}/svc/if/${cmd}?token=${token}`;
                    getAPI(CmdkUrl).then((res2) => {
                        if (res2 && res2.status === 200 && res2.data.length > 0) {
                        } else {
                            alert(`${ip} ${cmd}` + t("명령 전송 실패"));
                        }
                    })
                } else {
                    alert(`${ip} ` + t("연결에 실패하였습니다."));
                }
            })
        } catch (e) {
            console.log(e.message);
        } finally {
            setTimeout(() => setIsLoading(false), 1000); // 명령 후 1초 동안 모달 유지 후 닫기
        }
    }

    return (
        <div className="main-container">
            <div className="header">
                <Grid container>
                    <Grid item xs={10}>
                        {/* 상단메뉴명 */}
                        <UBreadCrumbs
                            title={"운영관리"}
                            subtitle={"장비관리"}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        {/* 툴바 버튼 */}
                        <Stack
                            direction="row"
                            justifyContent="flex-end"
                            alignItems="flex-start"
                            spacing={0.5}
                        >
                        </Stack>
                    </Grid>
                </Grid>
            </div>

            <div className="contents">
                <Box>
                    {/* 조회조건 */}
                    <TableContainer className="table-container">
                        <Table className="table" size="small">
                            <TableBody>
                                <TableRow className="table-row-header">
                                    <TableCell className="table-cell-title">{fni18n("고객사")}</TableCell>
                                    <TableCell className="table-cell">
                                        <USelectBox
                                            name="bizTy"
                                            items={retailers}
                                            onItemChange={onSearchChange}
                                        />
                                    </TableCell>
                                    <TableCell className="table-cell-title">{fni18n('지점')}</TableCell>
                                    <TableCell className="table-cell">
                                        {/* 점번선택 */}
                                        <USelectBox
                                            id="branch"
                                            name="branch"
                                            items={branchs}
                                            onItemChange={onSearchChange}
                                            defaultValue={search.branch}/>
                                    </TableCell>
                                    <TableCell className="table-cell-title">{fni18n('기기번호')}</TableCell>
                                    <TableCell className="table-cell">
                                        {/* 기번선택 */}
                                        <USelectBox
                                            id="machineNo"
                                            name="machineNo"
                                            items={machineNo}
                                            onItemChange={onSearchChange}/>
                                    </TableCell>
                                    <TableCell className="table-cell-title">{fni18n('사용여부')}</TableCell>
                                    <TableCell className="table-cell">
                                        {/* 사용여부 */}
                                        <USelectBox
                                            id="useYn"
                                            name="useYn"
                                            items={useYn}
                                            onItemChange={onSearchChange}/>
                                    </TableCell>
                                    {/* <TableCell className="table-cell-title">{fni18n('명세표 출력여부')}</TableCell>
                                    <TableCell className="table-cell">
                                        <USelectBox
                                            id="rctPrtYn"
                                            name="rctPrtYn"
                                            items={rctPrtYn}
                                            onItemChange={onSearchChange}/>
                                    </TableCell> */}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div className="search">
                        <UButton icon="Search" onButtonClick={onButtonClick}>조회</UButton>
                    </div>
                </Box>
                {/* 조회 리스트 */}
                <UTable
                    columns={columns}
                    rows={list}
                    onSelectedRowChange={onSelectedRows}
                    rowPerPage={11}
                    toolbarAdd={
                        <>
                            <UAuthButton
                                icon="Add"
                                menuFrom={location.pathname}
                                onButtonClick={onButtonClick}
                            >
                                추가
                            </UAuthButton>
                            &nbsp;&nbsp;
                            <UAuthButton
                                icon="Upload"
                                onButtonClick={handleExcelFormOpen}
                            >
                                업로드
                            </UAuthButton>
                        </>
                    }
                />
            </div>
            <UConfirmDialog
                message={confirmMsg}
                open={confirmPopupOpen}
                onClose={handleConfirmClose}
                onClickOk={handleRemoteConfirmOpen}
            />
             {/* 수정내용 기기에즉시적용(개국원격명령실행) 확인팝업추가 @2025-03-13 minjlee */}
            <UConfirmDialog
                message={remoteConfirmMsg}
                open={remoteConfirmPopupOpen}
                onClose={handleRemoteConfirmClose}
                onClickOk={handleRemoteConfirmOk}
            />
            <UAlertDialog
                message={errorMsg}
                open={errorPopupOpen}
                onClose={handleErrorClose}
            />
            {/* 팝업 */}
            <UPopupForm
                open={formOpen}
                onClose={handleFormClose}
                onSave={onSave}
                title='장비 설정'
                type={"2"}
                content={<MachineModify data={modify} onParamsChange={onModifyChange}
                                        onCheckboxChange={onCheckboxChange} onIpChange={onIpChange}
                                        onStoreChage={onModifyStoreChage} onRadioButtonChange={onRadioButtonChange}
                />}
            />

            {/* EXCEL UPLOAD */}
            <div>
                <Dialog
                    open={excelFormOpen}
                    onClose={handleExcelFormClose}
                    aria-labelledby="draggable-dialog-title"
                    fullWidth={true}
                    maxWidth="md">
                    <DialogTitle style={{
                        backgroundColor: "#F6F6F6",
                        color: "#2F2F2F",
                        borderBottom: "1px solid #444444",
                        height: "50px",
                        fontSize: "20px"
                    }} id="draggable-dialog-title" onClose={handleExcelFormClose}>
                        <Typography>{fni18n('업로드')}</Typography>
                        <IconButton
                            aria-label="close"
                            onClick={handleExcelFormClose}
                            sx={{
                                position: 'absolute',
                                right: 8,
                                top: 8,
                                color: (theme) => theme.palette.grey[500],
                            }}>
                            <CloseIcon/>
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>

                            {/* Excel 파일업로드  */}
                            <div className="pop-container">
                                <div className="contents">
                                    <TableContainer className="table-container">
                                        <Table className="table" size="small">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell className="table-cell-title">{fni18n('파일')}</TableCell>
                                                    <TableCell className="table-cell" colspan={3}>
                                                        <Button variant='text' color="primary"
                                                                onClick={() => fnExcelBrowser()}>
                                                            {fni18n('파일선택')}
                                                        </Button>
                                                        {selectedFiles && selectedFiles.map((data) => {
                                                            let icon;
                                                            return (
                                                                <item key={data.key}>
                                                                    <Chip
                                                                        icon={icon}
                                                                        label={data.label}
                                                                        onDelete={handleDelete(data)}/>
                                                                </item>
                                                            );
                                                        })}
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                            {/* END Excel 파일업로드 */}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{align: "center", backgroundColor: "#F6F6F6"}}>
                        <UAuthButton variant="contained" color="primary" onButtonClick={onButtonClick}>업로드</UAuthButton>
                        <UButton variant="outlined" onButtonClick={handleExcelFormClose}>닫기</UButton>
                    </DialogActions>

                    <Backdrop
                        sx={{color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1}}
                        open={backdropOpen}
                        //onClick={handleBackdropClose}
                    >
                        <CircularProgress color="inherit"/>
                    </Backdrop>
                </Dialog>
            </div>
            <div>
                {/* 로딩 중일 때 표시되는 모달 */}
                <Modal open={isLoading} style={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                    <div style={{
                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                        padding: '40px',
                        borderRadius: '8px',
                        textAlign: 'center',
                        color: 'white',
                        maxWidth: '600px'
                    }}>
                        <CircularProgress style={{color: 'white', marginBottom: '20px'}}/>
                        <Typography variant="h5">
                            Applying settings to the machine
                        </Typography>
                    </div>
                </Modal>
            </div>
        </div>
    );
}